import { createStore as reduxCreateStore, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga'
import moment from 'moment'

import reducer, { initialState } from './reducers'
import mySaga from './sagas'

const createStore = ({ ssr, browser }) => {
  const sagaMiddleware = createSagaMiddleware()
  const store = reduxCreateStore(
    reducer,
    {
      ...initialState,
      ssr: !!ssr,
      browser: !!browser,
      now: browser ? moment() : null,
    },
    applyMiddleware(sagaMiddleware)
  )
  sagaMiddleware.run(mySaga)
  return store
}

export default createStore



// WEBPACK FOOTER //
// ./src/state/createStore.js